module.exports = __webpack_public_path__ + "img/司机端app图标.0edd15aa.png";